// Website UI text that isn't Content (Content comes from the server in the chosen language).
// Keyed by the English text; columns follow `langs`. Brand words stay English: Crush, Wink, Blink, Super Crush,
// Break My Glass, Crushr, Winkr, Duo, Founding Crush, "Glass" as a counter label.
const SITE_DICT = {
  langs: ["fr", "es"],
  entries: {
    "How it works": ["Comment ça marche", "Cómo funciona"],
    "Plans": ["Formules", "Planes"],
    "Safety": ["Sécurité", "Seguridad"],
    "FAQ": ["FAQ", "Preguntas frecuentes"],
    "Home": ["Accueil", "Inicio"],
    "Terms": ["Conditions", "Términos"],
    "Privacy": ["Confidentialité", "Privacidad"],
    "Community guidelines": ["Règles de la communauté", "Normas de la comunidad"],
    "Support": ["Assistance", "Ayuda"],
    "Site": ["Site", "Sitio"],
    "Main": ["Principal", "Principal"],
    "Legal": ["Juridique", "Legal"],
    "Sections": ["Sections", "Secciones"],
    "Legal documents": ["Documents juridiques", "Documentos legales"],
    "Legal and support": ["Juridique et assistance", "Legal y ayuda"],
    "Skip to content": ["Aller au contenu", "Ir al contenido"],
    "Crushwink home": ["Accueil Crushwink", "Inicio de Crushwink"],
    "Switch to light theme": ["Passer au thème clair", "Cambiar al tema claro"],
    "Switch to dark theme": ["Passer au thème sombre", "Cambiar al tema oscuro"],
    "Language": ["Langue", "Idioma"],
    "Page not found": ["Page introuvable", "Página no encontrada"],
    "This page took a gentle pass.": ["Cette page a passé son tour, en douceur.", "Esta página pasó de largo, con calma."],
    "The link may be old, or the page moved.": ["Le lien est peut-être ancien, ou la page a changé d'adresse.", "Puede que el enlace sea antiguo o que la página se haya movido."],
    "Back to home": ["Retour à l'accueil", "Volver al inicio"],
    "Back home": ["Retour à l'accueil", "Volver al inicio"],
    "Website": ["Site web", "Sitio web"],
    "1 week": ["1 semaine", "1 semana"],
    "1 month": ["1 mois", "1 mes"],
    "3 months": ["3 mois", "3 meses"],
    "6 months": ["6 mois", "6 meses"],
    "Go home": ["Retour à l'accueil", "Volver al inicio"],
    "Feature": ["Fonctionnalité", "Función"],
    "Yes": ["Oui", "Sí"],
    "No": ["Non", "No"],
    "We couldn’t load this page.": ["Impossible de charger cette page.", "No pudimos cargar esta página."],
    "Try again": ["Réessayer", "Reintentar"],
    "Loading": ["Chargement", "Cargando"],
    "Loading…": ["Chargement…", "Cargando…"],
    // App mockups
    "Discover": ["Découvrir", "Descubrir"],
    "Crushes": ["Crushes", "Crushes"],
    "Chat": ["Chat", "Chat"],
    "Profile": ["Profil", "Perfil"],
    "Verified": ["Vérifié", "Verificado"],
    "Your crushes": ["Tes Crushes", "Tus Crushes"],
    "Breaking glass is free here": ["Briser la vitre est gratuit ici", "Romper el cristal es gratis aquí"],
    "Your chats": ["Tes conversations", "Tus chats"],
    "Maya winked": ["Maya t'a envoyé un Wink", "Maya te envió un Wink"],
    "Say the first hi": ["Dis bonjour en premier", "Saluda primero"],
    "LOOKING FOR": ["CHERCHE", "BUSCA"],
    "Serious relationship": ["Relation sérieuse", "Relación seria"],
    "The way to my heart is…": ["Le chemin vers mon cœur, c'est…", "El camino a mi corazón es…"],
    "Tacos and a good playlist.": ["Des tacos et une bonne playlist.", "Tacos y una buena playlist."],
    "Crushed on you": ["T'a envoyé un Crush", "Te envió un Crush"],
    "See you Saturday?": ["On se voit samedi ?", "¿Nos vemos el sábado?"],
    "Haha, same. Tacos then?": ["Haha, pareil. Des tacos, alors ?", "Jaja, igual. ¿Tacos entonces?"],
    "That trail looks amazing": ["Ce sentier a l'air génial", "Ese sendero se ve increíble"],
    "SOON": ["BIENTÔT", "PRONTO"],
    "Download on the App Store": ["Télécharger dans l'App Store", "Descargar en el App Store"],
    "Get it on Google Play": ["Disponible sur Google Play", "Disponible en Google Play"],
    "Coming soon on the": ["Bientôt sur l'", "Muy pronto en el"],
    "Coming soon on": ["Bientôt sur", "Muy pronto en"],
    // Waitlist
    "Email": ["E-mail", "Correo electrónico"],
    "Country": ["Pays", "País"],
    "City": ["Ville", "Ciudad"],
    "(optional)": ["(facultatif)", "(opcional)"],
    "State / province": ["État / province", "Estado / provincia"],
    "ZIP / postal code": ["Code postal", "Código postal"],
    "Postal code": ["Code postal", "Código postal"],
    "I am a": ["Je suis", "Soy"],
    "Choose": ["Choisir", "Elegir"],
    "Woman": ["Femme", "Mujer"],
    "Man": ["Homme", "Hombre"],
    "Nonbinary": ["Non binaire", "No binario"],
    "Other": ["Autre", "Otro"],
    "Prefer not to say": ["Je préfère ne pas le dire", "Prefiero no decirlo"],
    "Join the waitlist": ["Rejoindre la liste d'attente", "Unirme a la lista de espera"],
    "Joining…": ["Inscription…", "Uniéndote…"],
    "Enter a valid email address.": ["Saisis une adresse e-mail valide.", "Escribe un correo electrónico válido."],
    "Choose your country.": ["Choisis ton pays.", "Elige tu país."],
    "Enter a valid postal code.": ["Saisis un code postal valide.", "Escribe un código postal válido."],
    "Choose an option.": ["Choisis une option.", "Elige una opción."],
    "You're on the list.": ["Tu es sur la liste.", "Ya estás en la lista."],
    "You're already on the list.": ["Tu es déjà sur la liste.", "Ya estabas en la lista."],
    "One email when we open near you. No spam.": ["Un seul e-mail quand on ouvre près de chez toi. Pas de spam.", "Un solo correo cuando abramos cerca de ti. Sin spam."],
    "Add another email": ["Ajouter un autre e-mail", "Añadir otro correo"],
    "We'll write to {x} the moment Crushwink opens near you. Nothing else.": ["On écrira à {x} dès que Crushwink ouvre près de chez toi. Rien d'autre.", "Escribiremos a {x} en cuanto Crushwink abra cerca de ti. Nada más."],
    "{x} was already saved. We've updated your area and details.": ["{x} était déjà enregistré. On a mis à jour ta zone et tes infos.", "{x} ya estaba guardado. Actualizamos tu zona y tus datos."],
    "Pick a country": ["Choisir un pays", "Elegir un país"],
    "Search countries": ["Rechercher un pays", "Buscar países"],
    "No country found.": ["Aucun pays trouvé.", "No se encontró ningún país."],
    "Sanctioned": ["Sous sanctions", "Sancionado"],
    // Bot check, phone check, appeal, delete, contact
    "We couldn't confirm you're a person. Please try again in a moment.": ["Nous n'avons pas pu confirmer que tu es une personne. Réessaie dans un instant.", "No pudimos confirmar que eres una persona. Inténtalo de nuevo en un momento."],
    "Too many tries, please wait a few minutes.": ["Trop d'essais, patiente quelques minutes.", "Demasiados intentos, espera unos minutos."],
    "Phone number on your account": ["Numéro de téléphone de ton compte", "Número de teléfono de tu cuenta"],
    "Text me a code": ["M'envoyer un code par SMS", "Enviarme un código por SMS"],
    "We texted a code to": ["Nous avons envoyé un code au", "Enviamos un código al"],
    "Change number": ["Changer de numéro", "Cambiar número"],
    "6-digit code": ["Code à 6 chiffres", "Código de 6 dígitos"],
    "Sending…": ["Envoi…", "Enviando…"],
    "Checking…": ["Vérification…", "Comprobando…"],
    "Continue": ["Continuer", "Continuar"],
    "Your appeal": ["Ton appel", "Tu apelación"],
    "Send appeal": ["Envoyer l'appel", "Enviar apelación"],
    "This decision can't be appealed again.": ["Cette décision ne peut plus faire l'objet d'un appel.", "Esta decisión ya no se puede apelar."],
    "You've already appealed this decision. We'll email you when it's reviewed.": ["Tu as déjà fait appel de cette décision. On t'écrira dès qu'elle sera examinée.", "Ya apelaste esta decisión. Te escribiremos cuando la revisemos."],
    "Your account and its data have been deleted. Thank you for trying Crushwink.": ["Ton compte et ses données ont été supprimés. Merci d'avoir essayé Crushwink.", "Tu cuenta y sus datos se eliminaron. Gracias por probar Crushwink."],
    "Type DELETE to confirm": ["Tape DELETE pour confirmer", "Escribe DELETE para confirmar"],
    "This account has already been deleted.": ["Ce compte a déjà été supprimé.", "Esta cuenta ya se eliminó."],
    "Delete my account": ["Supprimer mon compte", "Eliminar mi cuenta"],
    "Deleting…": ["Suppression…", "Eliminando…"],
    "Contact us": ["Nous contacter", "Contáctanos"],
    "Topic": ["Sujet", "Tema"],
    "Message": ["Message", "Mensaje"],
    "General question": ["Question générale", "Pregunta general"],
    "Report a problem": ["Signaler un problème", "Informar de un problema"],
    "Press": ["Presse", "Prensa"],
    "Name (optional)": ["Nom (facultatif)", "Nombre (opcional)"],
    "Send message": ["Envoyer le message", "Enviar mensaje"],
    "Write a short message.": ["Écris un court message.", "Escribe un mensaje breve."],
    "Thanks. Your message is with us, and we'll reply by email.": ["Merci. Ton message nous est bien parvenu, on te répondra par e-mail.", "Gracias. Recibimos tu mensaje y te responderemos por correo."],
    "Crushwink is calm, intentional dating. You Crush, they Wink back, you send the first message. No pressure. All intention.": [
      "Crushwink, ce sont des rencontres calmes et sincères. Tu envoies un Crush, la personne répond par un Wink, tu envoies le premier message. Aucune pression. Que de l'intention.",
      "Crushwink son citas tranquilas y con intención. Tú envías un Crush, te devuelven un Wink y tú envías el primer mensaje. Sin presión. Pura intención."],
  },
};
export default SITE_DICT;
